import { isCleaningReference } from '@front/common/src/utils/universes';
import { UniverseReference } from '@front/common/src/types/commons';
import { useBooleanVariant } from '@front/common/src/providers/experiment-provider';

export type UseIsEligibleForInstantTaxCreditCleaningArgs = {
  universe?: UniverseReference;
};

export const useIsEligibleForInstantTaxCreditCleaning = ({
  universe,
}: UseIsEligibleForInstantTaxCreditCleaningArgs) => {
  const isInstantTaxCreditEnabled = useBooleanVariant('cst-cleaning-instant-tax-credit');

  return isInstantTaxCreditEnabled && isCleaningReference(universe);
};
